import {MaintainAppConfig, MaintainAppName} from '@hconnect/common/hproduce/maintain.types'

import {links as rcfaLinks, LinkTo} from '../../rcfa/routes'

type AppLinks = {
  [K in MaintainAppName]: LinkTo[]
}

const DIGITAL_TOOLS_PROD_URL = 'https://grafana.hcag.dev/d/maintain-prod-reliability'
const DIGITAL_TOOLS_NON_PROD_URL = 'https://grafana.hcag.dev/d/maintain-nonprod-landing-zone'

const dashboardLink: LinkTo = {
  translationKey: 'Dashboard',
  to: '',
  subItems: undefined,
  activateOnlyIfExact: true
}

const digitalToolsLink: LinkTo = {
  to: process.env.REACT_APP_STAGE === 'prod' ? DIGITAL_TOOLS_PROD_URL : DIGITAL_TOOLS_NON_PROD_URL,
  translationKey: 'Digital Tools'
}

const rcfaLink: LinkTo = {
  to: '/rcfa',
  translationKey: 'Root Cause Analysis',
  activateOnlyIfExact: true
}

const pmLinks: LinkTo[] = [
  {
    to: '/pm',
    translationKey: 'Plant Monitoring',
    activateOnlyIfExact: true
  },
  {
    to: '/pm/kms',
    translationKey: 'Kiln Monitoring',
    activateOnlyIfExact: false
  }
]

export const appLinks: AppLinks = {
  Rcfa: [dashboardLink, ...rcfaLinks, digitalToolsLink],
  PM: [dashboardLink, rcfaLink, ...pmLinks, digitalToolsLink],
  default: [dashboardLink, rcfaLink, ...pmLinks, digitalToolsLink],
  Maintain: []
}

const getAppLinks = (rcfaAllowed: boolean, pmAllowed: boolean): AppLinks => {
  const rcfaFiteredLink = rcfaAllowed ? [rcfaLink] : []
  const pmFitleredLinks = pmAllowed ? pmLinks : []

  return {
    Rcfa: [dashboardLink, ...rcfaLinks, digitalToolsLink],
    PM: [dashboardLink, ...rcfaFiteredLink, ...pmFitleredLinks, digitalToolsLink],
    default: [dashboardLink, ...rcfaFiteredLink, ...pmFitleredLinks, digitalToolsLink],
    Maintain: []
  }
}

const getNavItemUrl = (plantId: string, url: string) =>
  /^https?:\/\//i.test(url) ? url : `/plant/${plantId}${url}`

export const getNavItems = (
  appName: MaintainAppName,
  plantId: string,
  t,
  allowedApps: MaintainAppConfig[]
) => {
  const rcfaAllowed = allowedApps.some((app) => app.urlAlias === 'rcfa')
  const pmAllowed = allowedApps.some((app) => app.urlAlias === 'pm')

  const filteredAppLinks = getAppLinks(rcfaAllowed, pmAllowed)

  return filteredAppLinks[appName].map((link) => ({
    label: t(link.translationKey),
    url: getNavItemUrl(plantId, link.to),
    activateOnlyIfExact: link.activateOnlyIfExact,
    subItems: link.subItems?.map((subItem) => ({
      label: t(subItem.translationKey),
      url: getNavItemUrl(plantId, subItem.to),
      activateOnlyIfExact: subItem.activateOnlyIfExact
    }))
  }))
}
